import { teamActions } from '../teams/team-slice';
import { getData } from '../common-actions';
import { fetchTeams} from '../../lib/api';

export const getTeams = (token, signal) => {

  return getData({
    token: token,
    actions: teamActions,
    fetchFn: (token) => fetchTeams(token, signal),
    dataKey: "teams",
    name: "get getTeams",
    setFunctionName: "setTeams"
  });
};

